
<template>
  <Filters />
  <Table />
</template>
    
    <script>
import Filters from "../components/MainFilters.vue";
import Table from "../components/GeneralTable.vue";
export default {
  components: {
    Filters,
    Table,
  },
  setup() {
    return {};
  },
};
</script>
    <style module>
</style>
    